export const TESTING = "TESTING";
export const STAGING = "STAGING";
export const PRODUCTION = "PRODUCTION";

export const PROJECT_MODE = PRODUCTION;

export const isProd = PROJECT_MODE === PRODUCTION;
